<!--
  银行卡列表
-->

<template>
  <div>
    <title-header title='我的银行卡'></title-header>
    <div class='bank-card-cont'>
      <!-- 银行卡列表 -->
      <div class='card-item clearfix' v-for='(item, index) in cardList' :key='index'>
        <div class='bank-name'>{{item.bankName}}</div>
        <div class='card-type'>{{cardTypeList[item.type]}}</div>
        <div class='card-num'>
          <span class='hide-card-num'>····</span>
          <span class='hide-card-num'> ····</span>
          <span class='hide-card-num'> ····</span>
          <span class='show-card-num'> {{item.cardNo | getCardNumLastFour}}</span>
        </div>
        <div class='delete-card' @click='deleteCard(item)'>解除绑定</div>
      </div>
      <!-- 添加银行卡 -->
      <div class='add-bank-card' @click='addBankCard'>
        <van-icon name="plus" />
        <span class='add-word'>添加银行卡</span> 
      </div>
    </div>
  </div>
</template>

<script>
  import api from 'api/wallet';
  import { cardTypeMap } from 'common/js/bankname';
  import { Toast,Dialog  } from 'vant';
  export default {
    data() {
      return {
        cardList: [],
        cardTypeList: cardTypeMap
      }
    },
    computed: {
      cardNumLastFour() { //银行卡号最后4位

      }
    },
    created() {
      this.getBankCardList()
    },
    methods:{
      addBankCard() {
        this.$router.push({
          name:'addBankCard'
        })
      },
      //获取银行卡列表
      getBankCardList() {
        api.getBankCardList()
          .then(res => {
            this.cardList = res;
          })
      },
      //解绑银行卡
      deleteCard(item) {
        Dialog.confirm({
          title: '解绑提醒！',
          message: '确认解绑此银行卡吗'
        }).then(() => {
          api.deleteBankCard(item.id)
            .then(res => {
              Toast.success('解绑成功')
              this.getBankCardList()
            })
            .catch(err => {
              Toast.fail('解绑成功')
            })
        }).catch(() => {
          // on cancel
        });
      },
    },
    filters: {
      getCardNumLastFour(val) {
        return val.slice(-4)
      }
    }
  }
</script>

<style lang='scss' scoped>
  .bank-card-cont{
    padding: 15px;
    .card-item{
      position: relative;
      margin: 10px 0;
      padding: 15px;
      border-radius: 5px;
      background: rgb(26,102,164);
      color: #fff;
      .bank-name{
        font-weight: bold;
      }
      .card-type{
        font-size: 12px;
        color: #ddd;
      }
      .card-num{
        font-size: 18px;
        .hide-card-num{
          font-size: 28px;
          vertical-align: middle;
        }
        .show-card-num{
          vertical-align: sub;
        }
      }
      .delete-card{
        position: absolute;
        bottom: 10px;
        right:15px;
        font-size:14px;
        color:#f98181;
      }
    }
    .add-bank-card{
      padding: 15px;
      border: 1px solid #adadad;
      border-radius: 5px;
      .add-word{
        margin-left: 10px;
        vertical-align: text-bottom;
      }
    }
  }
</style>